import { Injectable } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { AudioEffectPlayer } from '../../utils/audio.utils';
import { RidCompressableKlankCard } from './rid-compressable-klank-card';

@Injectable({ providedIn: 'root' })
export class CompressibleCardsService {
  public async compress(cards: RidCompressableKlankCard[]) {
    if (cards.length <= 1) return;

    let didChange = false;

    cards.forEach((card, index) => {
      didChange ||= card.compressed()?.index !== index || card.compressed()?.length !== cards.length;

      card.compressed.set({ index, length: cards.length });
    });

    if (didChange) {
      AudioEffectPlayer.play('SHORT_SLIDE');
      await delay(250);
    }
  }

  public async decompress(cards: RidCompressableKlankCard[]) {
    if (cards.length <= 1) return;

    let didChange = false;

    cards.forEach((card) => {
      didChange ||= card.compressed() !== undefined;

      card.compressed.set(undefined);
    });

    if (didChange) {
      AudioEffectPlayer.play('SHORT_SLIDE');
      await delay(250);
    }
  }
}
